import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
// Services and Actions
import {
  fetchGetVehicles,
  fetchFilterVehicles,
  fetchLogout,
  downloadVehiclesFileCSV
} from 'alelo-logic/actions'
import { setLoading } from '../../modules/PageLoader/actions'
// Components
import IdentifiersList from '../../modules/IdentifiersList'
import {
  Heading,
  Paragraph,
  Content,
  SearchBox,
  LoadingContainer,
  LoadingText,
  SubHeader,
  HeadingContent,
  iconColor,
  CardAndIconWrap,
  ButtonIcon
} from './styles'
import SearchForm, { searchFilter } from 'app/modules/SearchForm'
import ManagementModal from 'app/modules/ManageInfoModal'
// Assets
import IconLoading from 'app/elements/Icon/ic-loading'
import { Icon } from '../../elements/Icon'

import {
  helmetTitle,
  identifiersTitle,
  identifiersDescription,
  noIdentifierTitle,
  noIdentifierDescription
} from './data.json'

import TotalIdentifiersCard from './TotalIdentifiersCard'
class DashboardIdentifiers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      itemsSelected: [],
      searchText: '',
      identifiersList: [],
      listGrowNumber: 20,
      isLoadingMoreItems: false,
      modalOpen: false,
      vehicle: {}
    }
  }

  async componentDidMount() {
    const { setLoading, match, history, fetchVehicles, account = {} } = this.props
    setLoading(true)
    const { id } = match.params
    // const { wl: isWhiteLabel = false } = account

    const { wl, pc } = account

    if (pc) {
      this.props.history.push(`/minha-veloe/${id}/identificadores-parceiro`)
      return
    }

    const isWhiteLabel = wl || pc || false

    if (!isWhiteLabel) {
      await fetchVehicles(history, id)
    } else {
      setLoading(false)
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { vehicles } = this.props
    if (prevProps.vehicles !== vehicles && vehicles.length > 0) {
      this._prepareVehiclesList()
    }
  }

  _prepareVehiclesList = () => {
    const { vehicles, setLoading } = this.props
    const { listGrowNumber } = this.state
    const newVehicles = this.handleSortIdentifier(vehicles)
    if (newVehicles.length > listGrowNumber) {
      this.setState({ identifiersList: newVehicles.slice(0, listGrowNumber) })
    } else {
      this.setState({ identifiersList: newVehicles })
    }
    setLoading(false)
  }

  handleSearchChange = ({ target }) => {
    this.setState({ searchText: target.value })
  }

  // Checkbox
  handleSelectItem = item => () => {
    const { itemsSelected } = this.state
    let newArray
    const hasItem =
      itemsSelected.findIndex(({ idIdentificador }) => item.idIdentificador === idIdentificador) !==
      -1
    if (hasItem) {
      newArray = itemsSelected.filter(
        ({ idIdentificador }) => item.idIdentificador !== idIdentificador
      )
      return this.setState({ itemsSelected: newArray })
    }
    newArray = [...itemsSelected, item]
    this.setState({ itemsSelected: newArray })
  }

  handleSelectAll = () => {
    const { itemsSelected, identifiersList } = this.state
    if (itemsSelected.length === identifiersList.length) {
      return this.setState({ itemsSelected: [] })
    }
    this.setState({ itemsSelected: identifiersList })
  }

  // Infinity List
  loadMoreItems = () => {
    const { identifiersList, listGrowNumber } = this.state
    const { vehicles } = this.props
    const newVehicles = this.handleSortIdentifier(vehicles)
    if (newVehicles.length !== identifiersList.length) {
      this.setState({ isLoadingMoreItems: true })
      setTimeout(
        () =>
          this.setState({
            isLoadingMoreItems: false,
            identifiersList: newVehicles.slice(0, identifiersList.length + listGrowNumber)
          }),
        400
      )
    }
  }

  // Modal
  handleModalCreateInfo = vehicle => {
    this.setState({ modalOpen: true, vehicle })
  }

  handleCloseModal = async () => {
    this.setState({ modalOpen: false, vehicle: {} })
    const { match, history, fetchVehicles } = this.props
    const { id } = match.params
    await fetchVehicles(history, id)
  }

  handleSortIdentifier = vehicle => {
    const newVehicle = vehicle.map(item => {
      item.order = this.getWarnTags(item.codIdentificador) ? -1 : 1
      return item
    })
    newVehicle.sort((a, b) => a.order - b.order)
    return newVehicle
  }

  getWarnTags = identifierId => {
    const listTagsWarn = JSON.parse(sessionStorage.getItem('warnTags'))
    return listTagsWarn && listTagsWarn.tags && listTagsWarn.tags.includes(parseInt(identifierId))
  }

  handleGetVehicle = (identifierNumber, next) => {
    this.props.dispatch(fetchFilterVehicles(identifierNumber)).then(resp => {
      const [identifier = {}] = resp || []

      if (identifier.codIdentificador) {
        this.setState({ identifiersList: [identifier] })
      }
    })
  }

  render() {
    const {
      searchText,
      itemsSelected,
      identifiersList,
      isLoadingMoreItems,
      modalOpen,
      vehicle
    } = this.state

    const { vehicles, account = {}, match } = this.props
    // const { wl: isWhiteLabel = false } = account
    const { wl, pc } = account

    const isWhiteLabel = wl || pc || false

    return (
      <section>
        <Helmet title={helmetTitle} />
        {!isWhiteLabel && (!identifiersList || identifiersList.length === 0) ? (
          <Content>
            <Heading>{noIdentifierTitle}</Heading>
            <Paragraph>{noIdentifierDescription}</Paragraph>
          </Content>
        ) : (
          <Content>
            <SubHeader>
              <HeadingContent>
                <Heading>{isWhiteLabel ? 'Consultar VeloeTag' : identifiersTitle}</Heading>
                <Paragraph>
                  {isWhiteLabel
                    ? 'Pesquise por número de VeloeTag para ver detalhes do dispositivo'
                    : identifiersDescription}
                </Paragraph>
              </HeadingContent>

              <SearchBox>
                <CardAndIconWrap>
                  <TotalIdentifiersCard account={match.params.id} />
                  <ButtonIcon
                    alt="Download Informações Adesivos em CSV"
                    title="Download Informações Adesivos em CSV"
                  >
                    <Icon
                      icon="download"
                      svgStyle={iconColor}
                      width="31"
                      height="31"
                      viewBox="0 0 70 70"
                      onClick={() => {
                        this.props.downloadCSVVehicles(match.params.id)
                      }}
                    />
                  </ButtonIcon>
                </CardAndIconWrap>

                {isWhiteLabel ? (
                  <SearchForm
                    width="100%"
                    value={searchText}
                    onChange={this.handleSearchChange}
                    onSearch={() => this.handleGetVehicle(searchText, false)}
                    placeholder="Pesquise por número da VeloeTag"
                  />
                ) : (
                  <SearchForm
                    width="100%"
                    value={searchText}
                    onChange={this.handleSearchChange}
                    placeholder="Busque pela placa, VeloeTag ou Informação gerencial"
                  />
                )}
              </SearchBox>
            </SubHeader>

            {isWhiteLabel ? (
              <IdentifiersList
                handleCreateInf={this.handleModalCreateInfo}
                checkboxValues={itemsSelected}
                handleLoadMoreItems={() => {}}
                handleSelectItem={this.handleSelectItem}
                handleSelectAll={this.handleSelectAll}
                identifiers={identifiersList}
              />
            ) : (
              <IdentifiersList
                handleCreateInf={this.handleModalCreateInfo}
                checkboxValues={itemsSelected}
                handleLoadMoreItems={this.loadMoreItems}
                handleSelectItem={this.handleSelectItem}
                handleSelectAll={this.handleSelectAll}
                identifiers={
                  searchText && searchText.length >= 3
                    ? searchFilter(searchText, vehicles)
                    : identifiersList
                }
              />
            )}
            {isLoadingMoreItems && (
              <LoadingContainer>
                <IconLoading />
                <LoadingText>Carregando</LoadingText>
              </LoadingContainer>
            )}
            {modalOpen && (
              <ManagementModal
                vehicle={vehicle}
                isOpen={modalOpen}
                modalStart={'include'}
                toggleModal={this.handleCloseModal}
              />
            )}
          </Content>
        )}
      </section>
    )
  }
}

export const mapStateToProps = ({ reducer }) => ({
  vehicles: reducer.dashboardVehicles,
  accountPlans: reducer.accountPlans,
  account: reducer.account
})

export const mapDispatchToProps = dispatch => ({
  fetchVehicles: (history, accountId) =>
    dispatch(fetchGetVehicles(accountId)).then(resp => {
      if (resp && (resp.status === 401 || resp.status === 403)) {
        dispatch(fetchLogout())
        history.push('/conta/login')
      }
      dispatch(setLoading(false))
    }),
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  },
  downloadCSVVehicles: planId =>
    dispatch(downloadVehiclesFileCSV(planId)).finally(() => dispatch(setLoading(false))),
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardIdentifiers)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardIdentifiers/index.js